import { render, staticRenderFns } from "./constructionDetail.vue?vue&type=template&id=cbafd6da"
import script from "./constructionDetail.vue?vue&type=script&lang=js"
export * from "./constructionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbafd6da')) {
      api.createRecord('cbafd6da', component.options)
    } else {
      api.reload('cbafd6da', component.options)
    }
    module.hot.accept("./constructionDetail.vue?vue&type=template&id=cbafd6da", function () {
      api.rerender('cbafd6da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/constructionDetail.vue"
export default component.exports